import styled from "styled-components";

export const DropzoneContainer = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px;
    border-width: 2px;
    border-radius: 2px;
    border-color: #C2C2C2;
    border-style: dashed;
    background-color: #EDEDED;
    color: #606060;
    outline: none;
    transition: border .24s ease-in-out;
`;